import { EventHub } from "@/constants/constants"
import { enterpriseService } from '@/services/enterprise.service'
import { ecologicalUnitService } from '@/services/ecological-unit.service'
import { farmService } from '@/services/farm.service'
import { DialogFarm } from "@/tools/dialog"
import { DialogEcologicalUnit } from "@/tools/dialog"
import { mapActions } from 'vuex'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'DriveUnitDialogFirstTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // selector de empresas
        enterprises: [],
        // selector de fincas
        farms: [],
        // selector de unidades ecológicas
        ecologicalUnits: [],
        // loading
        loadingEnterprises: false,
        loadingFarms: false,
        loadingEcologicalUnits: false,
        // model para el formulario
        isValidForm: false.valueOf(),
        //mascaras
        numberMask: ['/\\d{9}[0-9]$/'],
        selectedFarm: null,
        selectedEconologicalUnit: null,
    }),
    computed: {
    },
    async created () {
        // Evento lanzado por el diálogo de creación de finca, cuando se guarda la nueva finca
        this.$eventBus.$on(EventHub.COMMIT_FARM, async (farmDto) => {
            await this.getFarms(farmDto.name);
        })
        // Evento lanzado por el diálogo de creación de UE, cuando se guarda la nueva UE
        this.$eventBus.$on(EventHub.COMMIT_ECOLOGICAL_UNIT, (ecologicalUnitDto) => {
            this.getEcologicalUnits(ecologicalUnitDto.name);
        })
        this.getEnterprises()
    },
    beforeDestroy() {
        // desuscripción al bus de eventos
        this.$eventBus.$off(EventHub.COMMIT_FARM)
        this.$eventBus.$off(EventHub.COMMIT_ECOLOGICAL_UNIT)
    },
    async mounted () {
        await this.getFarms(this.model.farmId);
        this.getEcologicalUnits(this.model.ecologicalUnitId);
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        getEnterprises() {
            this.loadingEnterprises = true
            enterpriseService.getAllForSelector().then(response => {
                this.enterprises = response
                this.loadingEnterprises = false
            })
        },
        /**
         * Fincas
         * @param farmId id de la finca insertada
         */
        async getFarms (farmId) {
            if (this.model.enterpriseId) {
                this.loadingFarms =  true
                await farmService.findForSelector(this.model.enterpriseId).then(response => {
                    this.farms = response
                    if (farmId) {
                        this.selectedFarm = response.find(element => element.name == farmId)
                        this.model.farmId = this.selectedFarm.id                        
                    }
                    this.loadingFarms = false
                })
            }
        },
        /**
         * Unidades ecologicas
         */
        getEcologicalUnits(ecologicalUnitId) {
            if (this.model.enterpriseId && this.model.farmId) {
                this.loadingEcologicalUnits = true
                ecologicalUnitService.findForSelector(this.model.enterpriseId, this.model.farmId).then(response => {
                    this.ecologicalUnits = response
                    if (ecologicalUnitId) {
                        this.selectedEconologicalUnit = response.find(element => element.name == ecologicalUnitId)
                        this.model.ecologicalUnitId = this.selectedEconologicalUnit.id
                    }
                    this.loadingEcologicalUnits = false
                })
            }
        },
        /**
         * Carga el dialog para crear Fincas
         *
         */
         openFarm() {
            const bread = {
                key: DialogFarm,
                disabled: true,
                text: this.$t('farm.name'),
                model: { enterpriseId: this.model.enterpriseId, disableEnterpriseSelector: true }
            }
            this.pushBread(bread)
        },
        /**
         * Carga el dialog para crear Unidades de manejo
         *
         */
        openEcologicalUnit() {
            const bread = {
                key: DialogEcologicalUnit,
                disabled: true,
                text: this.$t('ecologicalUnit.name'),
                model: { enterpriseId: this.model.enterpriseId, farmId: this.model.farmId, disableEnterpriseSelector: true, disableFarmSelector: true }
            }
            this.pushBread(bread)
        },
        /**
         * Cada vez que se modifica la selección de la empresa, se cargan
         */
        enterpriseSelectedFunction (newValue) {
            this.model.enterpriseId = newValue._id ? newValue._id : newValue;
        },
        /**
         * Cada vez que se modifica la selección de la finca, se cargan
         */
        farmSelectedFunction (newValue) {
            this.model.farmId = newValue.id ? newValue.id : newValue;
        },
        /**
         * Cada vez que se modifica la selección de la unidad ecologica, se cargan
         */
        ecologicalUnitSelectedFunction (newValue) {
            this.model.ecologicalUnitId = newValue.id ? newValue.id : newValue;
        },
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.driveUnitDialogFirstTabForm) {
                this.$refs.driveUnitDialogFirstTabForm.resetValidation()
            }
        },
        "model.enterpriseId"() {
            this.model.farmId = null
            this.farms = []
            this.ecologicalUnits = []
            this.getFarms()
        },
        "model.farmId"() {
            this.ecologicalUnits = []
            this.getEcologicalUnits()
        }
    }
}
